import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import signUpStyle from "./SignUp.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export default function Signup() {

    const [data, setData] = useState([])
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phonePrimary, setPhonePrimary] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const token = localStorage.getItem("token");
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:5500/sign-up';

    // async fucntion to handdle the form submit 
    const handleSubmit = async (e) => {
        e.preventDefault()
        setError("");
        setSuccessMessage("");

        if (!firstName || !email || !phonePrimary || !password) {
            setError("Please fill all required fields.");
            return;
        }

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            const response = await fetch(`${apiUrl}/sign-up`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(
                    {
                        firstName,
                        lastName,
                        email,
                        password,
                        phonePrimary
                    })
            })
            const result = await response.json();

            if (!result) {
                setTimeout(() => {
                    setError('Data Error')
                }, 1000);
            }

            if (response.ok) {
                setSuccessMessage("Registration Successful! Redirecting to Login Page");
                setTimeout(() => {
                    navigate('/login');
                }, 1500);
                setData(result);
                console.log(data)
            } else {
                setError(result.message || "Signup failed.");
            }

        } catch (error) {
            setTimeout(() => {
                setError(error.message)
            }, 2000);
        }
    };

    return (
        <>
            <div className={signUpStyle.signuppage}>
                <div className={signUpStyle.signup}>

                    {/* error and message container */}
                    {error && <p className="text-danger text-center pt-4">{error}</p>}
                    {successMessage && <p className="text-success text-center pt-4">{successMessage}</p>}

                    {/* welcome msg container */}
                    <p className={`${signUpStyle.heading} text-center pt-4 `}>Welcome!</p>
                    <p className={`${signUpStyle.text} text-center pb-2`}>Sign up to get your account</p>

                    {/* form contianer to handle the field value  */}
                    <form onSubmit={handleSubmit} className="row">

                        {/* first Name field */}
                        <div className="col-6 mb-3">
                            <input
                                type="text"
                                placeholder="First Name"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                                className={signUpStyle.input}
                            />
                        </div>

                        {/* Last Name field */}
                        <div className="col-6 mb-3">
                            <input
                                type="text"
                                placeholder="Last Name"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                className={signUpStyle.input}
                            />
                        </div>

                        {/* Email Field */}
                        <div className="col-12 mb-3">
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className={signUpStyle.input}
                            />
                        </div>

                        {/* Primary Phone field */}
                        <div className="col-12 mb-3">
                            <input
                                type="text"
                                placeholder="Phone Number"
                                value={phonePrimary}
                                onChange={(e) => setPhonePrimary(e.target.value)}
                                required
                                className={signUpStyle.input}
                            />
                        </div>

                        {/* Password Field */}
                        <div className="col-12 col-sm-6 mb-3 position-relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className={signUpStyle.input}
                            />
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: "absolute",
                                    right: "25px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "gray",
                                }}
                            />
                        </div>

                        {/* Confirm Password Field */}
                        <div className="col-12 col-sm-6 mb-3 position-relative">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                className={signUpStyle.input}
                            />
                            <FontAwesomeIcon
                                icon={showConfirmPassword ? faEyeSlash : faEye}
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                style={{
                                    position: "absolute",
                                    right: "25px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "gray",
                                }}
                            />
                        </div>

                        {/* Submit button */}
                        <div className="col-12 text-center mt-3">
                            <button type="submit" className="btn btn-sm btn-outline-primary ">Signup</button>
                        </div>
                    </form>

                    {/* Login Btn to Already User */}
                    <p className={`${signUpStyle.text} pt-4 text-center`}>
                        Already a user? <Link to="/login">Login</Link>
                    </p>
                </div>
            </div>
        </>
    );
}
